import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel"];

  toggle(element) {
    this.panelTargets.forEach((panel) => {
      if (panel.contains(element.currentTarget)) {
        panel.classList.toggle("selected");
      } else {
        panel.classList.remove("selected");
      }
    });
  }
}
